var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"_main"},[_c('h2',{staticStyle:{"text-align":"center"}},[_vm._v("合同说明")]),_c('p',{staticStyle:{"text-align":"center","margin-top":"30px"}},[_vm._v(_vm._s(_vm.$route.query.info))])])
}
var staticRenderFns = []

export { render, staticRenderFns }